import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import ContactForm from "./ContactForm";
import ErrorBoundary from "./ErrorBoundary";
import GoogleMap from "./GoogleMap";
import { Waypoint } from "react-waypoint";

function ContactUs() {
  const [animateleft, setAnimateLeft] = useState("");
  const [animateUp, setAnimateUp] = useState("");
  const [animateRight, setAnimateRight] = useState("");

  const handleWaypointEnterLeft = () => {
    setAnimateLeft("visible animate__animated animate__fadeInLeft");
  };
  const handleWaypointEnterUp = () => {
    setAnimateUp("visible animate__animated animate__zoomIn");
  };
  const handleWaypointEnterRight = () => {
    setAnimateRight("visible animate__animated animate__fadeInRight");
  };

  return (
    <section className="contact-us" id="contact">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Waypoint onEnter={handleWaypointEnterRight}>
              <div className={`section-title hide ${animateRight}`}>
                <h1 className="title">Contact</h1>
                <h1 className="title title-fill">Me</h1>
              </div>
            </Waypoint>
          </div>

          <Waypoint onEnter={handleWaypointEnterLeft}>
            <div className={`col-lg-6 hide ${animateleft}`}>
              <ContactForm />
            </div>
          </Waypoint>

          <Waypoint onEnter={handleWaypointEnterUp}>
            <div className={`col-lg-6 hide ${animateUp}`}>
              <div className="google-map">
                <GoogleMap location="-35.425139,149.075061" />
              </div>
            </div>
          </Waypoint>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
